module.exports = __webpack_public_path__ + "9afd72e0335ce9a7.svg";